const normalize = value => String(value || "").toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "");
const words = value => new Set(normalize(value).split(/[^a-z0-9]+/).filter(word => word.length > 2));
const overlap = (left, right) => [...left].filter(value => right.has(value)).length;
const placeKey = place => String(place?.id ?? place?.name ?? "").trim();

const averagePrice = (placeId, reviews) => {
  const values = reviews.filter(review => String(review.placeid || review.placeId) === String(placeId)).map(review => Number(review.precio)).filter(Number.isFinite);
  return values.length ? values.reduce((sum, value) => sum + value, 0) / values.length : null;
};

const stableSeed = value => [...String(value || "")].reduce((sum, char, index) => sum + char.charCodeAt(0) * (index + 1), 0);

export const buildRelatedPlaces = (current, places = [], reviews = [], limit = 4) => {
  if (!current) return [];
  const currentKey = placeKey(current);
  const currentType = words(current.tipo);
  const currentZone = words(current.location);
  const currentPrice = averagePrice(current.id, reviews);
  const seen = new Set();
  const desired = Math.max(2, Math.min(4, limit));
  const ranked = places
    .filter(place => {
      const key = placeKey(place);
      if (!key || key === currentKey || seen.has(key) || place.pending || place.metadata?.rejected) return false;
      seen.add(key);
      return true;
    })
    .map(place => {
      const price = averagePrice(place.id, reviews);
      const category = overlap(currentType, words(place.tipo));
      const zone = overlap(currentZone, words(place.location));
      const priceCompatibility = currentPrice !== null && price !== null ? Math.max(0, 3 - Math.abs(currentPrice - price)) : 0;
      const preference = overlap(words(current.tags?.join(" ")), words(place.tags?.join(" ")));
      return { place, score: category * 8 + zone * 5 + priceCompatibility * 2 + preference };
    })
    .sort((a, b) => b.score - a.score || String(a.place.id).localeCompare(String(b.place.id), undefined, { numeric: true }));

  const poolSize = Math.min(ranked.length, Math.max(desired + 2, desired * 2));
  const pool = ranked.slice(0, poolSize);
  if (!pool.length) return [];
  const offset = stableSeed(currentKey) % pool.length;
  const rotated = pool.slice(offset).concat(pool.slice(0, offset));
  return rotated.slice(0, desired).map(item => item.place);
};
